import insuranceRouteList from "../Insurance/routeList";
import dashboardRouteList from "../MainDashboard/routeList";
import patientCareRouteList from "../PatientCare/routeList";
import reportsRoutesList from "../Reports/routesList";

  const PageRouterList = {
    login: "/login",
    authentication:"authentication",
    expired:"ui/expired",
    unauthorized:"ui/unauthorized",
    forgotPassword:"forgot-password",
    patientFeedback:"ui/patient-feedback/:clinicId/:patientId",
     ...dashboardRouteList,
     ...insuranceRouteList,
     ...patientCareRouteList,
     ...reportsRoutesList
  }

  export default PageRouterList